import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";
import { API_URL } from "src/config";
import axios from "axios";
// import refreshAccessToken from './views/refresh-token/RefreshToken'
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function AuthenticatedRoute({ children }) {
  const [cookiesValue, setCookiesValue] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const navigat = useNavigate();
  // const [tokenRefresh, setTokenRefresh] = useState(false)

  const validTokens = useCallback(async () => {
    if (cookiesValue) {
      const token = cookiesValue;
      console.log("Token:", token);
      // console.log('tokenRefresh:', tokenRefresh)
      // Start token validation
      axios
        .post(
          `${API_URL}/token/verify/`,
          { token },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Token verification status:", response.status);
          if (response.status === 200) {
            console.log("Token is valid");
            setIsLoading(false);
          } else {
            console.error("Token is invalid, removing it from cookies");
            Cookies.remove("access_token");
            Cookies.remove("refresh_token");
            navigat("/login");
          }
        })
        .catch((error) => {
          Cookies.remove("access_token");
          Cookies.remove("refresh_token");
          console.error("Token is invalid, removing it from cookies");
          console.error("Error:", error);
          navigat("/login");
        });
    } else {
      setIsLoading(false);
      console.log("Token not found ------------------");
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      navigat("/login");
    }
  });

  useEffect(() => {
    setCookiesValue(Cookies.get("access_token"));
  }, []);

  useEffect(() => {
    if (cookiesValue) {
      validTokens();
    } else {
      setIsLoading(false);
    }
  }, [cookiesValue]);

  if (isLoading) {
    return <div>Loading...</div>; // or replace with a loading component
  }

  return cookiesValue ? children : <Navigate to="/login" />;
}

AuthenticatedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthenticatedRoute;
